import { ChatBubble } from "@/components/ai/chat/ChatBubble";
import { Banner } from "@/components/flexkit/Banner";
import type { AgentMessageFragment, Message } from "@/hooks/use-stream-conversation";
import type { PlainAgentExecution } from "@/queries/agent-queries";
import { type FC } from "react";

type ChatMessagesProps = {
    messages: Message[];
    onClick: (block: AgentMessageFragment) => void;
    agentExecution: PlainAgentExecution;
};

export const ChatMessages: FC<ChatMessagesProps> = ({ messages, onClick, agentExecution }) => {
    return (
        <div className="mx-auto flex h-full w-full max-w-[700px] flex-col items-start gap-4 p-6">
            {messages.map((message, index) => (
                <ChatBubble
                    agentExecution={agentExecution}
                    key={message.id}
                    message={message}
                    onClick={onClick}
                    isLast={index === messages.length - 1}
                />
            ))}
            {agentExecution?.status?.warningMessage && (
                <Banner
                    variant="warning"
                    text={agentExecution.status.warningMessage}
                    data-testid="agent-execution-warning-banner"
                />
            )}
            {agentExecution?.status?.failureMessage && (
                <Banner
                    variant="danger"
                    text={agentExecution.status.failureMessage}
                    data-testid="agent-execution-failure-banner"
                />
            )}
        </div>
    );
};
